// extracted by mini-css-extract-plugin
export default {"hiddenInput":"hiddenInput__3QiFz","crop":"crop__2b5H9","dropzoneText":"dropzoneText__18KJC","dropzoneBox":"dropzoneBox__1tDFC"};